import { useContext } from "react";
import {
  SubscriptionModalContext,
  type SubscriptionModalContextValue,
} from "@components/job_alerts/subscription_modal.tsx";

const useSubscriptionModal = (): SubscriptionModalContextValue => {
  const context = useContext(SubscriptionModalContext);

  if (!context) {
    throw new Error("useSubscriptionModal must be used within a SubscriptionModalProvider");
  }

  return context;
};

export default useSubscriptionModal;
